import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function ExerciseDetailPage() {
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    // Redirect based on exercise type
    if (id?.startsWith('reading')) {
      navigate('/reading');
    } else if (id?.startsWith('writing')) {
      navigate('/writing');
    } else if (id?.startsWith('listening')) {
      navigate('/listening');
    } else if (id?.startsWith('speaking')) {
      navigate('/speaking');
    } else {
      navigate('/dashboard');
    }
  }, [id, navigate]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
      <div className="animate-pulse text-slate-600">Redirigiendo...</div>
    </div>
  );
}
